import type { SVGComponentProps } from 'BreetHelpers';

export const FirstBeneficiaryIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='101'
		height='101'
		viewBox='0 0 101 101'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			x='0.5'
			y='0.191406'
			width='100'
			height='100'
			rx='50'
			fill='#CDECF2'
		/>
		<path
			opacity='0.4'
			d='M50.5007 50.1917C56.2536 50.1917 60.9173 45.528 60.9173 39.7751C60.9173 34.0221 56.2536 29.3584 50.5007 29.3584C44.7477 29.3584 40.084 34.0221 40.084 39.7751C40.084 45.528 44.7477 50.1917 50.5007 50.1917Z'
			fill='#05A2BF'
		/>
		<path
			d='M50.4995 55.3999C40.062 55.3999 31.562 62.3999 31.562 71.0249C31.562 71.6082 32.0203 72.0666 32.6037 72.0666H68.3953C68.9787 72.0666 69.437 71.6082 69.437 71.0249C69.437 62.3999 60.937 55.3999 50.4995 55.3999Z'
			fill='#05A2BF'
		/>
	</svg>
);
